import { render } from "./advisorList.vue?vue&type=template&id=2a1c4989"
import script from "./advisorList.vue?vue&type=script&lang=js"
export * from "./advisorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__